import { ResponseType, useIsLoggedQuery } from '@/graphql/generated'
import { pathURL } from '../constants/urls'
import { Navigate } from 'react-router'
import styled from 'styled-components'
import { LoadingSpinner } from '../ui/atoms'
import useUserDataContext from '@/customHooks/useUserDataContext'

const SpinnerContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const RootRedirector = () => {
  const {data, loading} = useIsLoggedQuery()
  const { clearUserData } = useUserDataContext()
  
  if (loading) return (
    <SpinnerContainer>
      <LoadingSpinner />
      <p>Loading</p>
    </SpinnerContainer>
  )

  if (data?.isLogged.responseType === ResponseType.Success) {
    return <Navigate to={`/${pathURL.USER}`} replace />
  } else {
    clearUserData()
    
    return <Navigate to={`/${pathURL.LOGIN}`} replace />
  }
}